// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderClaimPayment,
    ProviderEOB,
    ProviderEOBSortType,
    SupportClaimPayment,
    SupportCreateEOBPayload,
    SupportEOB,
    SupportEOBSortType,
    SupportUpdateEOBPayload,
    SupportCreateEOBPayloadToJSON,
    SupportUpdateEOBPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderClaimPaymentFromJSON,
    ProviderEOBFromJSON,
    SupportClaimPaymentFromJSON,
    SupportEOBFromJSON,
} from '../models';

export interface AddSupportPaymentToEOBRequest {
    eid: string;
    pid: string;
}

export interface DisableSupportEOBRequest {
    id: string;
}

export interface GetProviderEOBRequest {
    id: string;
}

export interface GetProviderEOBPaymentsRequest {
    id: string;
}

export interface GetSupportEOBRequest {
    id: string;
}

export interface GetSupportEOBPaymentsRequest {
    id: string;
}

export interface ListProviderEOBsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderEOBsOrderEnum>;
    filterCreated?: Array<string>;
    sort?: Array<ProviderEOBSortType>;
}

export interface ListSupportEOBsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportEOBsOrderEnum>;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterStarred?: string;
    sort?: Array<SupportEOBSortType>;
}

export interface PostSupportEOBRequest {
    supportCreateEOBPayload: SupportCreateEOBPayload;
}

export interface RemoveSupportPaymentToEOBRequest {
    eid: string;
    pid: string;
}

export interface UpdateSupportEobRequest {
    id: string;
    supportUpdateEOBPayload: SupportUpdateEOBPayload;
}

/**
 * no description
 */
export class ExplanationOfBenefitsApi extends runtime.BaseAPI {

    /**
     * Add a Payment to an EOB
     * Add a Payment to an EOB
     */
    async addSupportPaymentToEOBRaw(requestParameters: AddSupportPaymentToEOBRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['eid'] === null || requestParameters['eid'] === undefined) {
            throw new runtime.RequiredError('eid','Required parameter requestParameters.eid was null or undefined when calling addSupportPaymentToEOB.');
        }

        if (requestParameters['pid'] === null || requestParameters['pid'] === undefined) {
            throw new runtime.RequiredError('pid','Required parameter requestParameters.pid was null or undefined when calling addSupportPaymentToEOB.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:eob", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/eob/{eid}/payment/{pid}`.replace(`{${"eid"}}`, encodeURIComponent(String(requestParameters.eid))).replace(`{${"pid"}}`, encodeURIComponent(String(requestParameters.pid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Add a Payment to an EOB
     * Add a Payment to an EOB
     */
    async addSupportPaymentToEOB(requestParameters: AddSupportPaymentToEOBRequest): Promise<ObjectNoResponse> {
        const response = await this.addSupportPaymentToEOBRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable an EOB
     * Disable the EOB
     */
    async disableSupportEOBRaw(requestParameters: DisableSupportEOBRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportEOB.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:eob", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/eob/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable an EOB
     * Disable the EOB
     */
    async disableSupportEOB(requestParameters: DisableSupportEOBRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportEOBRaw(requestParameters);
        return await response.value();
    }

    /**
     * Test Background Request
     * Test Background Request
     */
    async getBackgroundRequestRaw(): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:eob", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/test/background`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Test Background Request
     * Test Background Request
     */
    async getBackgroundRequest(): Promise<ObjectNoResponse> {
        const response = await this.getBackgroundRequestRaw();
        return await response.value();
    }

    /**
     * Gets an EOB
     * Gets an EOB
     */
    async getProviderEOBRaw(requestParameters: GetProviderEOBRequest): Promise<runtime.ApiResponse<ProviderEOB>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderEOB.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:eob"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/eob/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderEOBFromJSON(jsonValue));
    }

    /**
     * Gets an EOB
     * Gets an EOB
     */
    async getProviderEOB(requestParameters: GetProviderEOBRequest): Promise<ProviderEOB> {
        const response = await this.getProviderEOBRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of EOB payments
     * Gets a list of EOB payments associated with a given EOB
     */
    async getProviderEOBPaymentsRaw(requestParameters: GetProviderEOBPaymentsRequest): Promise<runtime.ApiResponse<Array<ProviderClaimPayment>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderEOBPayments.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payment"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/eob/{id}/payment`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderClaimPaymentFromJSON));
    }

    /**
     * Gets a list of EOB payments
     * Gets a list of EOB payments associated with a given EOB
     */
    async getProviderEOBPayments(requestParameters: GetProviderEOBPaymentsRequest): Promise<Array<ProviderClaimPayment>> {
        const response = await this.getProviderEOBPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an EOB
     * Gets an EOB
     */
    async getSupportEOBRaw(requestParameters: GetSupportEOBRequest): Promise<runtime.ApiResponse<SupportEOB>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportEOB.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:eob", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/eob/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportEOBFromJSON(jsonValue));
    }

    /**
     * Gets an EOB
     * Gets an EOB
     */
    async getSupportEOB(requestParameters: GetSupportEOBRequest): Promise<SupportEOB> {
        const response = await this.getSupportEOBRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of EOB payments
     * Gets a list of EOB payments associated with a given EOB
     */
    async getSupportEOBPaymentsRaw(requestParameters: GetSupportEOBPaymentsRequest): Promise<runtime.ApiResponse<Array<SupportClaimPayment>>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportEOBPayments.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:eob", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/eob/{id}/payment`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportClaimPaymentFromJSON));
    }

    /**
     * Gets a list of EOB payments
     * Gets a list of EOB payments associated with a given EOB
     */
    async getSupportEOBPayments(requestParameters: GetSupportEOBPaymentsRequest): Promise<Array<SupportClaimPayment>> {
        const response = await this.getSupportEOBPaymentsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of EOBs
     * Get a list of EOBs
     */
    async listProviderEOBsRaw(requestParameters: ListProviderEOBsRequest): Promise<runtime.ApiResponse<Array<ProviderEOB>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:eob"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/eob`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderEOBFromJSON));
    }

    /**
     * Gets a list of EOBs
     * Get a list of EOBs
     */
    async listProviderEOBs(requestParameters: ListProviderEOBsRequest): Promise<Array<ProviderEOB>> {
        const response = await this.listProviderEOBsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of EOBs
     * Get a list of EOBs
     */
    async listSupportEOBsRaw(requestParameters: ListSupportEOBsRequest): Promise<runtime.ApiResponse<Array<SupportEOB>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:eob", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/eob`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportEOBFromJSON));
    }

    /**
     * Gets a list of EOBs
     * Get a list of EOBs
     */
    async listSupportEOBs(requestParameters: ListSupportEOBsRequest): Promise<Array<SupportEOB>> {
        const response = await this.listSupportEOBsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a paper EOB
     * Create a paper EOB
     */
    async postSupportEOBRaw(requestParameters: PostSupportEOBRequest): Promise<runtime.ApiResponse<SupportEOB>> {
        if (requestParameters['supportCreateEOBPayload'] === null || requestParameters['supportCreateEOBPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateEOBPayload','Required parameter requestParameters.supportCreateEOBPayload was null or undefined when calling postSupportEOB.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:eob", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/eob`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateEOBPayloadToJSON(requestParameters['supportCreateEOBPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportEOBFromJSON(jsonValue));
    }

    /**
     * Create a paper EOB
     * Create a paper EOB
     */
    async postSupportEOB(requestParameters: PostSupportEOBRequest): Promise<SupportEOB> {
        const response = await this.postSupportEOBRaw(requestParameters);
        return await response.value();
    }

    /**
     * Remove a Payment from an EOB
     * Remove a Payment from an EOB
     */
    async removeSupportPaymentToEOBRaw(requestParameters: RemoveSupportPaymentToEOBRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['eid'] === null || requestParameters['eid'] === undefined) {
            throw new runtime.RequiredError('eid','Required parameter requestParameters.eid was null or undefined when calling removeSupportPaymentToEOB.');
        }

        if (requestParameters['pid'] === null || requestParameters['pid'] === undefined) {
            throw new runtime.RequiredError('pid','Required parameter requestParameters.pid was null or undefined when calling removeSupportPaymentToEOB.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:eob", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/eob/{eid}/payment/{pid}`.replace(`{${"eid"}}`, encodeURIComponent(String(requestParameters.eid))).replace(`{${"pid"}}`, encodeURIComponent(String(requestParameters.pid))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Remove a Payment from an EOB
     * Remove a Payment from an EOB
     */
    async removeSupportPaymentToEOB(requestParameters: RemoveSupportPaymentToEOBRequest): Promise<ObjectNoResponse> {
        const response = await this.removeSupportPaymentToEOBRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update an EOB
     * Update an EOB
     */
    async updateSupportEobRaw(requestParameters: UpdateSupportEobRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportEob.');
        }

        if (requestParameters['supportUpdateEOBPayload'] === null || requestParameters['supportUpdateEOBPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateEOBPayload','Required parameter requestParameters.supportUpdateEOBPayload was null or undefined when calling updateSupportEob.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:eob", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/eob/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateEOBPayloadToJSON(requestParameters['supportUpdateEOBPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update an EOB
     * Update an EOB
     */
    async updateSupportEob(requestParameters: UpdateSupportEobRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportEobRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderEOBsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportEOBsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
